import React from 'react';
import { useTranslate } from '@bynder/localization';
import {
	StyledHeadingNoButton,
	StyledHeadingWrapper,
	StyledResultsSection,
} from './StyledComponents';
import { useSearch } from '../SpotlightState';

export const NoResults = () => {
	const { searchTerm } = useSearch();
	const { translate } = useTranslate();

	return (
		<StyledResultsSection>
			<StyledHeadingWrapper>
				<StyledHeadingNoButton>
					<div>
						{translate('generalNoResultsFor')} <b>{searchTerm}</b>
					</div>
				</StyledHeadingNoButton>
			</StyledHeadingWrapper>
		</StyledResultsSection>
	);
};
